import { defineStore } from "pinia";

export const useGenericStore = defineStore("generic", {
  state: () => ({
    formErrors: {},
    snackbar: {
      title: "",
      description: "",
      timeout: 2000,
      type: "",
      showProgress: false,
      position: "bottom-left",
      isOpen: false,
      globalWarning: null,
    },
    paymentMethods: [
      {
        id: 1,
        title: "Stripe",
        image: "/images/payments/1.svg",
        checkoutImage: "/images/payments/checkout/stripe.webp",
        optionImage: "/images/payments/checkout/stripe_options.webp",
        options: ["Visa", "Mastercard", "Amex", "JCB", "Union Pay"],
        status: 1,
      },
      {
        id: 10,
        title: "Stripe",
        image: "/images/payments/1.svg",
        checkoutImage: "/images/payments/checkout/stripe.webp",
        optionImage: "/images/payments/checkout/stripe_options.webp",
        options: ["Visa", "Mastercard", "Amex", "JCB", "Union Pay"],

        status: 1,
      },
      {
        id: 2,
        title: "Skrill",
        image: "/images/payments/2.svg",
        checkoutImage: "/images/payments/checkout/skrill.webp",
        optionImage: "/images/payments/checkout/skrill_options.webp",
        options: ["RapidTransfer", "Skrill", "Neteller"],
        status: 1,
      },
      {
        id: 3,
        title: "Paysafe Card",
        image: "/images/payments/3.svg",
        checkoutImage: "/images/payments/checkout/paysafe.webp",
        optionImage: "/images/payments/checkout/paysafe_options.webp",
        // options: ["Paysafe Cards"],

        status: 1,
      },
      {
        id: 4,
        title: "PayPal",
        image: "/images/payments/4.svg",
        checkoutImage: "/images/payments/checkout/paypal.webp",
        optionImage: "/images/payments/checkout/paypal_options.webp",
        status: 1,
        options: [
          "Paypal Wallet",
          "Visa",
          "Mastercard",
          "Amex",
          "JCB",
          "Union Pay",
        ],
      },
      {
        id: 5,
        title: "Direct Bank Transfer",
        image: "/images/payments/4.svg",
        checkoutImage: "/images/payments/checkout/bank.webp",
        optionImage: "/images/payments/checkout/bank_options.webp",
        options: [
          "GiroPay",
          "IDEAL",
          "Sofort",
          "EPS",
          "P24",
          "Bancontact",
          "Przelewy24",
          "SEPA",
        ],
        status: 1,
      },
      {
        id: 6,
        title: "Coinbase",
        image: "/images/payments/4.svg",
        checkoutImage: "/images/payments/checkout/coinbase.webp",
        optionImage: "/images/payments/checkout/coinbase_options.webp",
        options: ["Bitcoin", "Ethereum", "Litecoin"],

        status: 1,
      },
      {
        id: 7,
        title: "Apple Pay",
        image: "/images/payments/7.svg",
        checkoutImage: "/images/payments/checkout/apple_pay.webp",
        status: 1,
      },
      {
        id: 8,
        title: "Google Pay",
        image: "/images/payments/8.svg",
        checkoutImage: "/images/payments/checkout/google_pay.webp",
        status: 1,
      },
      {
        id: 9,
        title: "Boosting Market Coin",
        image: "/images/payments/9.svg",
        checkoutImage: "/images/payments/checkout/bm_coins.webp",
        status: 1,
      },
    ],
    currencies: [],
    isLoginOpen: false,
    alert: {
      isOpen: false,
      type: "success",
      title: "",
      description: "",
    },

    active_tab: "menu-tab",
    basePrice: 0,
  }),
  getters: {
    getBasePrice: (state) => state.basePrice,
    getActiveTab: (state) => state.active_tab,
    getFormErrors: (state) => state.formErrors,
    getSnack: (state) => state.snackbar,
    getPaymentMethods: (state) => state.paymentMethods,
    getCurrencies: (state) => state.currencies,
    getKeyedCurrencies: (state) => {
      if (state.currencies.length > 0) {
        return state.currencies?.reduce((accumulator, value) => {
          return { ...accumulator, [value.id]: value.code };
        }, {});
      }
      return {};
    },
    getAlert: (state) => state.alert,
    getloginOpen: (state) => state.isLoginOpen,
  },
  actions: {
    setBasePrice(payload) {
      this.$patch({
        basePrice: payload,
      });
    },
    setActiveTab(payload) {
      this.$patch({
        active_tab: payload,
      });
    },
    setStoreFormErrors(payload) {
      this.$patch({
        formErrors: {
          ...payload,
        },
      });
    },
    setAlert(payload) {
      this.$patch({
        alert: {
          isOpen: true,
          type: payload.type || "success",
          title: payload.title || "",
          description: payload.description || "",
        },
      });
    },
    setSnack(payload) {
      this.$patch({
        snackbar: {
          title: payload.title,
          description: payload.description,
          timeout: payload.timeout || 1500,
          showProgress: payload.showProgress || false,
          type: payload.type,
          position: payload.position || "bottom-left",
          isOpen: true,
        },
      });
    },
    resetSnack() {
      this.$patch({
        snackbar: {
          title: "",
          description: "",
          timeout: 500,
          showProgress: false,
          type: "",
          position: this.snackbar.position,
          isOpen: false,
        },
      });
    },
    resetAlert() {
      this.$patch({
        alert: {
          isOpen: false,
          type: "success",
          title: "",
          description: "",
        },
      });
    },
    toggleLoginOpen() {
      this.$state.isLoginOpen = !this.$state.isLoginOpen;
    },

    async fetchCurrencies() {
      try {
        const { data: response } = await useApiFetch("/api/get-currencies", {
          fetchKey: "currencies",
        });
        if (response.value?.data) {
          this.$patch({
            currencies: [...response.value.data],
          });
        }
      } catch (error) {}
    },

    async fetchGlobalWarning() {
      const { data: response, error } = await useApiPost(
        "/api/get-global-warning",
        {
          method: "POST",
        }
      );
      if (response) {
        // console.log(response.value?.data);
        this.$patch({
          globalWarning: response,
        });
        // this.$patch({
        //   currencies: [...response.value.data],
        // });
      }
    },
  },
});
